import Color from "colorjs.io";

export const contrastColorAlgorithm = "WCAG21";

export const getAverageRGBfromImage = (image) => {
  const canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;

  if (image && canvas) {
    const context = canvas.getContext("2d");

    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const backgroundColorApproximation = context.getImageData(
      0,
      0,
      canvas.width,
      canvas.height,
      { willReadFrequently: true }
    );

    const [r, g, b] = extractAvgColor(backgroundColorApproximation);
    return { r, g, b };
  }
};

export const hexToRgb = (hex) => {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ].join(",")
    : null;
};

export const getContrastColor = (color) => {
  let rgb = color.replace(/[^\d,]/g, "").split(",");
  let yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
  return yiq >= 128 ? "black" : "white";
};

export const extractAvgColor = (data) => {
  let length = data.data.length;

  let i = 0,
    count = 0,
    r = 0,
    g = 0,
    b = 0;

  for (i = 0; i < length; i += 4) {
    ++count;

    r += data.data[i];
    g += data.data[i + 1];
    b += data.data[i + 2];
  }

  return [r / count, g / count, b / count];
};

export const calculateAverageRGB = (
  canvas,
  context,
  content,
  width,
  height
) => {
  // Draw the image on canvas
  context.drawImage(content, 0, 0, width, height);

  // Get image data
  let imageData = context.getImageData(0, 0, width, height);
  let data = imageData.data;

  // Variables to accumulate the sum of RGB values
  let r = 0,
    g = 0,
    b = 0;

  for (let i = 0; i < data.length; i += 4) {
    r += data[i];
    g += data[i + 1];
    b += data[i + 2];
  }

  // Calculate average RGB values
  let pixelCount = width * height;
  r = Math.round(r / pixelCount);
  g = Math.round(g / pixelCount);
  b = Math.round(b / pixelCount );


  let result = { r, g, b };
    content.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
    // console.log('average RGB result...', result);

  return result;
};

export const calculateContrast = (r, g, b) => {
  const backgroundColor = new Color(`rgb(${r}, ${g}, ${b})`);
  const white = new Color(`rgb(${255}, ${255}, ${255})`);
  const black = new Color(`rgb(${0}, ${0}, ${0})`);

  let whiteContrast = Math.abs(
    backgroundColor.contrast(white, contrastColorAlgorithm)
  );
  let blackContrast = Math.abs(
    backgroundColor.contrast(black, contrastColorAlgorithm)
  );

  return { whiteContrast, blackContrast };
};
